import {defineStore} from 'pinia'
import type {ShowEventPublicOutput} from "~/api/generated";

const STORE_NAME = 'buyPreference';

interface buyPreference {
    preferenceData: string | undefined;
    enablePurchase: boolean;
    possibleTicketQuantity: number | undefined;
    possibleShowPriceId: number | undefined | null;
    possibleDonatePrice: number | undefined | null;
}

const initialState = {
    preferenceData: undefined,
    enablePurchase: false,
    possibleTicketQuantity: undefined,
    possibleShowPriceId: undefined,
    possibleDonatePrice: undefined,
} as buyPreference;

export const useBuyStore = defineStore(STORE_NAME, {
    state: () => (
        {preference: initialState as buyPreference}
    ),
    persist: {
        storage: persistedState.localStorage,
    },
    actions: {
        setBuyPreference(
            showEvent: ShowEventPublicOutput,
            possibleTicketQuantity: number,
            possibleShowPriceId: number | null,
            possibleDonatePrice: number | null,
        ) {
            this.$state.preference.preferenceData = base64Encode(JSON.stringify(showEvent))
            this.$state.preference.enablePurchase = true;
            this.$state.preference.possibleTicketQuantity = possibleTicketQuantity;
            this.$state.preference.possibleShowPriceId = possibleShowPriceId;
            this.$state.preference.possibleDonatePrice = possibleDonatePrice;
        },
        getPreference(): buyPreference {
            return this.$state.preference
        },
        getShowEvent(): ShowEventPublicOutput|undefined {
            if (this.$state.preference.preferenceData === undefined) {
                return undefined;
            }
            const possibleShowEvent = base64Decode(this.$state.preference.preferenceData??'')

            if (possibleShowEvent === undefined) {
                return undefined;
            }

            return possibleShowEvent as ShowEventPublicOutput;
        },
        _reset() {
            console.log('reset')
            // this.preference = initialState as buyPreference
            // this.$reset()
            this.$state.preference.preferenceData = undefined
            this.$state.preference.enablePurchase = false;
            this.$state.preference.possibleTicketQuantity = undefined;
            this.$state.preference.possibleShowPriceId = undefined;
            this.$state.preference.possibleDonatePrice = undefined;
        }
    }
})
